import classNames from 'classnames'
import { type FC, type HTMLAttributes } from 'react'
import * as styles from './styles'

export type FooterProps = HTMLAttributes<HTMLDivElement>
/**
 * @note This **MUST NOT** be rendered inside Modal `<Body>`; its spacing (margins etc) within Modal `<Content>` depends
 * on it being a sibling to `<Body>`.
 */
export const Footer: FC<FooterProps> = ({ children, className, ...props }) => (
  <footer
    className={classNames([styles.classes.footer, className])}
    css={styles.modalFooter}
    {...props}
  >
    {children}
  </footer>
)
Footer.displayName = 'Lapidary: Footer ← Modal'
